import { render, staticRenderFns } from "./providerList.vue?vue&type=template&id=5e546368&scoped=true&"
import script from "./providerList.vue?vue&type=script&lang=babel&"
export * from "./providerList.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e546368",
  null
  
)

export default component.exports